import React from 'react';
import { Button } from '@/components/ui/button';
import { DollarSign } from 'lucide-react';

/* eslint-disable react/prop-types */
export function PayoutsBanner({ payoutStatus, isEmployee, onSetup }) {
  if (isEmployee || !payoutStatus) return null;
  if (payoutStatus.charges_enabled && payoutStatus.payouts_enabled) return null;

  return (
    <div
      data-testid="payouts-banner"
      className="mb-8 p-4 rounded-xl border border-amber-200 bg-amber-50 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
    >
      <div className="flex items-start gap-3">
        <DollarSign className="w-5 h-5 text-amber-600 mt-0.5" />
        <div>
          <div className="font-semibold text-amber-900">
            {payoutStatus.connected ? 'Finish setting up payouts' : 'Enable automatic payouts'}
          </div>
          <div className="text-sm text-amber-800">
            {payoutStatus.connected
              ? 'Complete your Stripe onboarding to start receiving tenant payments directly.'
              : 'Connect Stripe to get paid automatically when tenants book your properties.'}
          </div>
        </div>
      </div>
      <Button
        data-testid="payouts-banner-btn"
        onClick={onSetup}
        className="rounded-full bg-amber-600 hover:bg-amber-700 text-white shrink-0"
      >
        {payoutStatus.connected ? 'Continue Setup' : 'Set Up Payouts'}
      </Button>
    </div>
  );
}
/* eslint-enable react/prop-types */
